import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { startCheckout, openPortal } from "../lib/billing";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle, Clock, Loader2, Lock } from "lucide-react";

export const SubscriptionBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user || user.role === "super_admin") return;
    api.get("/billing/subscription").then(({ data }) => setSub(data)).catch(() => {});
  }, [user]);

  if (!sub || sub.state === "legacy" || sub.state === "active") return null;

  const isAdmin = user?.role === "admin";
  const usePortal = sub.state === "grace" || sub.reason === "payment_failed";

  const act = async () => {
    if (!isAdmin) { navigate("/plans"); return; }
    setBusy(true);
    try {
      if (usePortal) await openPortal();
      else await startCheckout(sub.plan, sub.interval || "monthly");
    } catch { setBusy(false); }
  };

  const cta = (
    <button type="button" onClick={act} disabled={busy}
            className="wl-btn wl-btn--primary wl-btn--sm flex-shrink-0" data-testid="sub-banner-cta">
      {busy ? <Loader2 size={14} className="animate-spin" />
        : usePortal ? "Aggiorna il pagamento" : "Attiva l'abbonamento"}
    </button>
  );

  if (sub.state === "trialing") {
    return (
      <div className="flex items-center justify-between gap-3 px-4 py-2 text-sm border-b"
           style={{ background: "var(--wl-accent-subtle, #eef4ff)", borderColor: "var(--wl-border)" }}
           data-testid="sub-banner-trial">
        <span className="flex items-center gap-2 text-text-primary">
          <Clock size={14} className="text-accent" />
          Prova gratuita del piano {sub.plan_name}: <strong>{sub.days_left} {sub.days_left === 1 ? "giorno rimasto" : "giorni rimasti"}</strong>
        </span>
        {cta}
      </div>
    );
  }
  if (sub.state === "grace") {
    return (
      <div className="flex items-center justify-between gap-3 px-4 py-2 text-sm border-b"
           style={{ background: "var(--wl-warning-bg, #fff8e1)", borderColor: "var(--wl-border)" }}
           data-testid="sub-banner-grace">
        <span className="flex items-center gap-2 text-text-primary">
          <AlertTriangle size={14} style={{ color: "var(--wl-warning-text, #b45309)" }} />
          Pagamento non riuscito: aggiorna il metodo di pagamento per non passare in sola lettura.
        </span>
        {cta}
      </div>
    );
  }
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 text-sm border-b"
         style={{ background: "var(--wl-danger-bg, #fef2f2)", borderColor: "var(--wl-border)" }}
         data-testid="sub-banner-readonly">
      <span className="flex items-center gap-2 text-text-primary">
        <Lock size={14} style={{ color: "var(--wl-danger-text, #b91c1c)" }} />
        Abbonamento non attivo: la piattaforma è in <strong>sola lettura</strong> (i tuoi dati sono al sicuro).
      </span>
      {cta}
    </div>
  );
};
